import { parseISO } from "date-fns";
import { useState } from "react";
import { ReactComponent as Logo } from "../../assets/img/logo-icon.svg";
import { FavoriteButton } from "components/elements/FavoriteButton";
import { useUserTimezone } from "hooks/useUserTimezone";
import { formatISODateRelative } from "lib/formatISODate";
import { renderSanitizedHTML } from "lib/renderSanitizedHTML";

type BlogPreviewType = {
    title: string | null | undefined;
    description: string | null;
    date: string | null;
    link?: string | null;
    imageUrl?: string | null;
    feedSourceTitle?: string | null;
    articleId?: number | null;
};

export const RssFeedCard = ({
    title,
    description,
    date,
    link = "",
    imageUrl,
    feedSourceTitle,
    articleId,
}: BlogPreviewType) => {
    const timeZone = useUserTimezone();
    const [imgError, setImgError] = useState(false);
    return (
        <a
            href={link || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-full w-full cursor-pointer text-inherit no-underline hover:no-underline focus:outline-none"
        >
            <div className="flex w-full flex-col gap-2 overflow-hidden rounded-2xl border border-[#c8c8c8] bg-[#fafffe] p-2">
                <div className="h-40 overflow-hidden rounded-2xl bg-gray-100">
                    {imageUrl && !imgError ? (
                        <img
                            src={imageUrl}
                            alt=""
                            onError={() => setImgError(true)}
                            className="h-full w-full object-cover"
                        />
                    ) : (
                        <Logo className="h-full w-full object-cover" />
                    )}
                </div>

                <div className="flex flex-grow flex-col gap-2 px-1">
                    <div className="mt-2 flex flex-row items-center justify-between gap-2">
                        <div className="font-sans text-xs font-normal text-gray-500">
                            {date
                                ? parseISO(date).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                      timeZone,
                                  })
                                : ""}
                        </div>
                        <div className="flex items-center gap-1">
                            {articleId != null && (
                                <FavoriteButton
                                    target={{ type: "feedArticle", id: articleId }}
                                    size={14}
                                />
                            )}
                        </div>
                    </div>

                    <div className="line-clamp-2 font-sans text-[14px] font-semibold leading-[125%] text-[#424242]">
                        {title}
                    </div>

                    {description && (
                        <p
                            className="mb-1.5 font-sans text-sm font-normal text-[#424242]"
                            {...renderSanitizedHTML(description)}
                        ></p>
                    )}

                    {(feedSourceTitle || date) && (
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                            {feedSourceTitle && (
                                <span className="font-semibold text-[#424242]">
                                    {feedSourceTitle}
                                </span>
                            )}
                            {date && (
                                <>
                                    {feedSourceTitle && <span>·</span>}
                                    <span>{formatISODateRelative(date)}</span>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </a>
    );
};
